.base {
	composes: interactive from './base.module.css';
}

.button {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	gap: var(--lp-spacing-200);
	margin: 0;
	text-decoration: none;
	appearance: none;
	border-radius: var(--lp-border-radius-medium);
	border: none;
	outline: none;
	white-space: nowrap;
	position: relative;
}

.button[data-focus-visible] {
	outline: 2px solid var(--lp-color-shadow-interactive-focus);
	outline-offset: -2px;
	z-index: 2;
}

.button[data-disabled] {
	opacity: 0.64;
}

.small {
	font: var(--lp-text-label-2-semibold);
	padding: calc(3px + var(--lp-button-padding, 0px)) var(--lp-spacing-300);
}

.medium {
	font: var(--lp-text-label-1-semibold);
	padding: calc(5px + var(--lp-button-padding, 0px)) var(--lp-spacing-300);
}

.large {
	font: var(--lp-text-body-1-semibold);
	padding: calc(7px + var(--lp-button-padding, 0px)) var(--lp-spacing-400);
}

.default {
	composes: button;
	--lp-button-padding: 0px;
	background-color: var(--lp-color-bg-interactive-secondary-base);
	border: 1px solid var(--lp-color-border-interactive-secondary-base);
	color: var(--lp-color-text-ui-primary-base);
}

.default[data-hovered] {
	background-color: var(--lp-color-bg-interactive-secondary-hover);
}

.default[data-pressed] {
	background-color: var(--lp-color-bg-interactive-secondary-active);
}

.default[data-focus-visible] {
	background-color: var(--lp-color-bg-interactive-secondary-focus);
}

.primary {
	composes: button;
	--lp-button-padding: 1px;
	background-color: var(--lp-color-bg-interactive-primary-base);
	color: var(--lp-color-text-interactive-primary-base);
	z-index: 1;

	& [data-icon] {
		fill: var(--lp-color-text-interactive-primary-base);
	}
}

.primary[data-hovered] {
	background-color: var(--lp-color-bg-interactive-primary-hover);
	color: var(--lp-color-text-interactive-primary-hover);
}

.primary[data-pressed] {
	background-color: var(--lp-color-bg-interactive-primary-active);
	color: var(--lp-color-text-interactive-primary-active);
}

.primary[data-focus-visible] {
	background-color: var(--lp-color-bg-interactive-primary-focus);
	box-shadow: inset 0 0 0 3px var(--lp-color-shadow-interactive-primary);
	color: var(--lp-color-text-interactive-primary-focus);
}

.destructive {
	composes: button;
	--lp-button-padding: 1px;
	background-color: var(--lp-color-bg-interactive-destructive-base);
	color: var(--lp-color-text-interactive-primary-base);

	& [data-icon] {
		fill: var(--lp-color-text-interactive-primary-base);
	}
}

.destructive[data-hovered] {
	background-color: var(--lp-color-bg-interactive-destructive-hover);
}

.destructive[data-pressed] {
	background-color: var(--lp-color-bg-interactive-destructive-active);
}

.destructive[data-focus-visible] {
	background-color: var(--lp-color-bg-interactive-destructive-focus);
	box-shadow: inset 0 0 0 3px var(--lp-color-shadow-interactive-primary);
}

.minimal {
	composes: button;
	--lp-button-padding: 1px;
	background-color: var(--lp-color-bg-interactive-tertiary-base);
	color: var(--lp-color-text-ui-primary-base);
}

.minimal[data-hovered] {
	background-color: var(--lp-color-bg-interactive-tertiary-hover);
}

.minimal[data-pressed] {
	background-color: var(--lp-color-bg-interactive-tertiary-active);
}

.minimal[data-focus-visible] {
	background-color: var(--lp-color-bg-interactive-tertiary-focus);
}

.button[data-selected]:where(button, label) {
	background-color: var(--lp-color-bg-interactive-selected);
	border-color: var(--lp-color-border-interactive-selected);
	z-index: 1;
}

.button[data-pending] {
	cursor: wait;

	& [data-icon] {
		opacity: 50%;
	}
}

.pending {
	opacity: 50%;
}

.progress {
	--fill-color: currentColor;
}

.picker {
	composes: base from './Input.module.css';
	/* biome-ignore lint/suspicious/noDuplicateProperties: safe */
	composes: _default from './Input.module.css';
	composes: group from './Group.module.css';

	& [data-icon]:last-child {
		fill: var(--lp-color-fill-ui-secondary);
	}
}
